<script lang="ts">
import { defineComponent, h } from 'vue';

import { makeTagProps, useRender } from '../../composable';

export const componentName = 'CdsCardText';
export default defineComponent({
  name: componentName,
  props: {
    ...makeTagProps()
  },
  setup(props, { slots }) {
    useRender(() =>
      h(
        props.tag,
        {
          class: 'cds-card-text'
        },
        slots.default?.()
      )
    );

    return {};
  }
});
</script>
